import { ProvidedConfig, getProvidedConfig } from "./utilities/provided-config";
import "./utilities/cypress-global-extension";

interface Config extends ProvidedConfig {
    env: string;
    connected: boolean;
    pollingFrequencyInMS: number;
    autoRefreshTargetTime: string;
}

const env = import.meta.env.MODE;
const envConnected = import.meta.env.VITE_CONNECTED
    ? import.meta.env.VITE_CONNECTED === "true"
    : false;
const connected = env === "production" || envConnected;
const pollingFrequencyInMS = import.meta.env.DEV ? 5 * 1000 : 30 * 1000;
const autoRefreshTargetTime = "06:00:00";

const providedConfig: ProvidedConfig = getProvidedConfig(env);

const combinedConfig: Config = {
    ...providedConfig,
    env: env || "unknown",
    connected,
    pollingFrequencyInMS,
    autoRefreshTargetTime
};

export default combinedConfig;
